import { Button, Space, Typography } from "antd";
import type { ReactNode } from "react";

export function PageHeaderActions({
  title,
  left,
  right
}: {
  title: string;
  subtitle?: string;
  left?: ReactNode;
  right?: ReactNode;
}) {
  return (
    <div className="page-header-actions">
      <div className="page-title-block">
        <Typography.Title level={3}>{title}</Typography.Title>
        {left}
      </div>
      <Space wrap className="page-action-row">
        {right}
      </Space>
    </div>
  );
}

export const ActionButton = Button;
